
import {
  defineStore
} from 'pinia'

export const useFaqsStore = defineStore('FaqsStore', {
  state: () => {
    return {
      faqs: [],
      categories: [],
      searchQuery: ''
    }
  },

  actions: {
    setFaqs (faqs, categories) {
      this.faqs = faqs
      this.categories = categories
    },
    updateSearchQuery (query) {
      this.searchQuery = query.toLowerCase()
    },
    clearSearch () {
      this.searchQuery = ''
    }
  },

  getters: {
    categoriesWithFaqs () {
      return this.categoriesFiltered.map(category => {
        return {
          ...category,
          faqs: this.faqsFiltered.filter(faq => faq.faqCategory === category.title)
        }
      })
    },

    categoriesFiltered () {
      if (this.searchQuery === '') return this.categories
      return this.categories.filter(category => {
        let match = false
        this.faqsFiltered.forEach(faq => {
          if (faq.faqCategory === category.title) {
            match = true
            return
          }
        })
        return match
      })
    },

    faqsFiltered () {
      if (this.searchQuery.length <= 2) return this.faqs
      return this.faqs.filter(faq => {
        return faq.title.toLowerCase().includes(this.searchQuery) || faq.answer.toLowerCase().includes(this.searchQuery) || faq.faqCategory.toLowerCase().includes(this.searchQuery)
      })
    }
  },
})
